import { render, staticRenderFns } from "./failed.vue?vue&type=template&id=2006570c&scoped=true&"
import script from "./failed.vue?vue&type=script&lang=js&"
export * from "./failed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006570c",
  null
  
)

export default component.exports